import { Directive, ElementRef, OnChanges, SimpleChanges, OnDestroy, NgZone, Input } from '@angular/core';
import { NgModel } from '@angular/forms';
declare var $: any;
import * as moment from 'moment';
@Directive({
  selector: 'input[appDatepicker]'
})
export class DatepickerDirective implements OnChanges, OnDestroy {
  @Input() datepickerOptions: any = {};
  private queryEl: any;
  viewValue: string;
  modelValue: any;
  private config: any = {
    container: 'body',
    showTopbar: false,
    stickyMonths: true,
    startDate: moment(new Date()).format('YYYY-MM-DD'),
    endDate: moment(new Date().setFullYear(new Date().getFullYear() + 1)).format('YYYY-MM-DD')
  }

  private date1: any = '';
  private date2: any = '';

  constructor(
    private elementRef: ElementRef,
    private zone: NgZone,
    public model: NgModel,
  ) {
    this.queryEl = $(this.elementRef.nativeElement);
    this.setDatepicker();
    this.datepickerEvents();
    this.onModelChanges();
  }

  /**
   *  on destroy
   */
  ngOnDestroy() {
    this.unpicker();
  }

  unpicker() {
    this.zone.run(() => {
      this.queryEl.data('dateRangePicker').destroy();
    });
  }

  /**
   * on changes
   * @param changes parametros actualizados
   * @description
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.datepickerOptions) {
      this.updateConfig(this.datepickerOptions);
    }
  }

  setDatepicker(keepDate = false) {
    this.queryEl.dateRangePicker(this.config);
    if (keepDate) {
      setTimeout(() => {
        this.setValue(this.date1 ? moment(this.date1).format('YYYY-MM-DD') : '', this.date2 ? moment(this.date2).format('YYYY-MM-DD') : '')
      });
    }
  }

  datepickerEvents() {
    this.queryEl.bind('datepicker-first-date-selected', (event, obj) => {
      this.date1 = new Date(obj.date1);
      this.date2 = '';
      this.emitValue();
    }).bind('datepicker-change', (event, obj) => {
      this.date1 = new Date(obj.date1);
      this.date2 = new Date(obj.date2);
      this.emitValue();
    });
  }

  updateConfig(newConfig) {
    this.config = {
      ...this.config,
      ...newConfig
    };
    this.unpicker();
    this.setDatepicker(true);
  }

  isToday(someDate) {
    return this.sameDate(new Date(), someDate);
  }

  sameDate(date, date2) {
    if (date && date2) {
      return date2.getDate() == date.getDate() &&
        date2.getMonth() == date.getMonth() &&
        date2.getFullYear() == date.getFullYear()
    }
    return false;
  }

  setValue(date1, date2) {
    this.queryEl.data('dateRangePicker').setDateRange(date1, !this.config.singleDate ? date2 : '', true);
    this.emitValue();
  }

  emitValue() {
    this.model.viewToModelUpdate(this.getModelValue());
    if (this.model.valueAccessor) {
      this.model.valueAccessor.writeValue(this.getViewValue());
    }
  }

  clear() {
    this.zone.run(() => {
      this.queryEl.data('dateRangePicker').clear();
    });
    this.date1 = '';
    this.date2 = '';
    setTimeout(() => {
      this.emitValue();
    });
  }


  getModelValue() {
    return [
      this.date1 ? moment(this.date1).format('DD-MM-YYYY') : '',
      this.date2 && !this.config.singleDate ? moment(this.date2).format('DD-MM-YYYY') : ''
    ].filter(x => x != '');
  }

  getViewValue() {
    let res = '';
    res += `${this.date1 ? moment(this.date1).format('DD-MM-YYYY') : ''}`;
    res += `${this.date2 && !this.config.singleDate ? (', ' + moment(this.date2).format('DD-MM-YYYY')) : ''}`;
    return res;
  }

  open(evt = null) {
    if(evt) {
      evt.stopPropagation();
    }
    this.queryEl.data('dateRangePicker').open();
  }

  onModelChanges() {
    this.model.valueChanges.subscribe(value => {
      if (value) {
        let date1 = value[0] ? moment(value[0], 'DD-MM-YYYY') : '';
        let date2 = value[1] && !this.config.singleDate ? moment(value[1], 'DD-MM-YYYY') : '';
        this.date1 = date1 ? (date1 as any).toDate() : '';
        this.date2 = date2 && !this.config.singleDate ? (date2 as any).toDate() : '';
        this.setValue(date1 ? (date1 as any).format('YYYY-MM-DD') : '', date2 ? (date2 as any).format('YYYY-MM-DD') : '');
      }
    });
  }

}
